import gql from 'graphql-tag';
import { RESPONSE_TYPE } from './ResponseType.gql';

export const EMAIL_PREDICTION_REPORT_TO_ADMIN_QUERY = gql`
  ${RESPONSE_TYPE}
  query emailPredictionReportToAdmin($responseId: ID!, $userId: ID!) {
    emailPredictionReportToAdmin(responseId: $responseId, userId: $userId) {
      ...ResponseType
    }
  }
`;
